import axios, { AxiosError } from 'axios'
import { useQuery } from 'react-query'
import { getAppConfigSetting } from '../utils'
import { ACCOUNTS_API } from './constants'
import queryKeys from './queryKeys'
import { SearchAccountsResponsePayload } from '@Types'

export const buildApiUrl = (accountQuery: string) => {
  const baseUrl = getAppConfigSetting('apiUrl')
  return `${baseUrl}${ACCOUNTS_API}?q=${accountQuery}`
}

export default function useGetSearchAccount(accountQuery: string) {
  const getSearchAccountsUrl = buildApiUrl(accountQuery)
  const getAccounts = async () => {
    const { data } = await axios.get(getSearchAccountsUrl, {
      withCredentials: true
    })
    return data as SearchAccountsResponsePayload[]
  }

  return useQuery<SearchAccountsResponsePayload[], AxiosError>(queryKeys.searchAccounts, getAccounts, {
    enabled: false
  })
}
